import { render, staticRenderFns } from "./modal-membership-types-settings.vue?vue&type=template&id=1c099e24&scoped=true"
import script from "./modal-membership-types-settings.vue?vue&type=script&lang=js"
export * from "./modal-membership-types-settings.vue?vue&type=script&lang=js"
import style0 from "./modal-membership-types-settings.vue?vue&type=style&index=0&id=1c099e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c099e24",
  null
  
)

export default component.exports